import { reloadPage } from '../../tools/Routing.ts';

export const useErrorController = () => {
  const tryAgain = () => {
    reloadPage();
  };

  return { tryAgain };
};
